import { VITE_DOIT_VOLUNTEER_URL } from '~/config';

export const getVolunteerActivityUrl = (activityId: string) => {
  return `${VITE_DOIT_VOLUNTEER_URL}my-wallet/activities/${activityId}`;
};
